import React, { useEffect, useState, useRef } from 'react';
import { Routes, useNavigate, useLocation } from "react-router-dom";

import routes from '../../libs/routes';
import images from "../../libs/images";
import * as API from "../../libs/service";


import { useDispatch, useSelector } from 'react-redux';

import { loadingStart, loadingEnd } from "../../redux/loadingSlice";
import { open, close } from "../../redux/popupSlice";

import Popup01 from "../../pages/popup/Popup01"

import { ToastContainer, toast, Slide, Flip, Bounce } from 'react-toastify';
import { BrowserView, MobileView, isBrowser, isMobile, isChrome, isSafari, isIOS, isAndroid } from 'react-device-detect';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Autoplay } from 'swiper/modules';



import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/autoplay';
import 'react-toastify/dist/ReactToastify.css';

import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

import HLSVideo from '../../libs/hlsVideo';


const CONTENT_ITEMS = [
    {
        title: { ko: '워크플로우 최적화', en: 'Optimize Your Workflow' },
        description: {
        ko: 'UModeler X와 생성형 AI를 함께 사용하여 보다 트렌디한 작업 환경을 조성하고, 이를 통해 압도적인 생산성을 경험해 보세요. 최신 기술을 활용한 직관적인 모델링과 자동화된 창작 과정이 결합되어 작업 속도를 극대화하고, 창의적인 아이디어를 더욱 빠르게 실현할 수 있습니다.',
        en: 'By using UModeler X with Generative AI, you can directly customize  the generated models, enabling faster and more efficient work.  This combination allows you to accelerate your workflow,  leveraging cutting-edge modeling and automated creative processes  to bring your ideas to life more swiftly.'
        },
        video: ("/m3u8/ai_01.m3u8"),
        thum: require("../../assets/thumnails/ai_01_thum.webp"),
        reverse: false
    },
    {
        title: { ko: 'AI 텍스처링', en: 'AI Texturing' },
        description: {
        ko: '스테이블 디퓨젼 API를 UModeler X에 매끄럽게 통합하여 효율적인 AI 기반 텍스처 매핑을 구현할 수 있습니다. UI에서 직접 AI가 생성한 이미지를 3D 메시에 적용하여 빠르고 정밀한 디자인을 제작할 수 있습니다.',
        en: 'Seamlessly integrate the Stable Diffusion API within  UModeler X for efficient AI-driven texture mapping.  Apply AI-generated images to 3D meshes directly  from the UI for quick and precise design creation.'
        },
        video: ("/m3u8/ai_02.m3u8"),
        thum: require("../../assets/thumnails/ai_02_thum.webp"),
        reverse: true
    },
    {
        title: { ko: '생성형 AI 모델링 활용', en: 'Utilizing AI-generated 3D Modeling' },
        description: {
        ko: 'AI로 생성한 3D 모델을 Unity에서 바로 불러와 자유롭게 편집하고 커스터마이징하세요. 실시간으로 변경 사항을 확인하며 모델의 형태와 텍스처를 손쉽게 조정할 수 있어 더욱 효율적인 작업이 가능합니다.',
        en: 'Directly edit and customize AI-generated 3D models in Unity with ease. Adjust the model\'s shape and textures in real time, allowing for a more efficient workflow by immediately seeing changes.'
        },
        video: ("/m3u8/ai_03.m3u8"),
        thum: require("../../assets/thumnails/ai_03_thum.webp"),
        reverse: false
    }
];

export default function AI() {
    const location = useLocation();
    
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const lang = useSelector(state => state.langReducer.lang);

    const [supBtnHover, setSupBtnHover] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    
    useEffect(() => {

    }, []);
    
    
    return (
        <>
            <div className="main_back">
                <div className="main_part padding">
                    <div className="header_page_title_box">
                        <p className="title">
                            {lang === 0 ? '생성형 AI 활용' : 'Gen AI Utilization'}
                        </p>
                        <span className="sub_title">
                            {lang === 0 ? ' AI로 생성된 3D 모델을 편집하거나 이미지를 텍스처로 적용시키세요.' : 'Edit AI-generated 3D models or apply images as textures.'}
                        </span>
                    </div>

                    {/* 콘텐츠 섹션 */}
                    <div className="header_page_content_box">
                        {CONTENT_ITEMS.map((item, index) => {
                        return (
                            <div className={`content ${item.reverse ? 'end' : ''}`} key={index}>
                            {item.reverse ? (
                                <>
                                <div className="title_box">
                                    <p>{lang === 0 ? item.title.ko : item.title.en}</p>
                                    <span style={{ whiteSpace: 'pre-line' }}>
                                    {lang === 0 ? item.description.ko : item.description.en}
                                    </span>
                                </div>
                                {index === 9999 ?
                                <div className="img_box_169" >
                                    <img src={item.video} alt={`content-${index}`} />
                                </div>
                                :
                                <div className="img_box">
                                    <HLSVideo 
                                    width="100%" 
                                    height="100%" 
                                    autoPlay 
                                    muted 
                                    loop 
                                    playsInline
                                    poster={item.thum}
                                    src={item.video}
                                    >
                                    소개 영상입니다.
                                    </HLSVideo>
                                </div>}
                                </>
                            ) : (
                                <>
                                {index === 9999 ?
                                <div className="img_box_169" >
                                    <img src={item.video} alt={`content-${index}`} />
                                </div>
                                :
                                <div className="img_box">
                                    <HLSVideo 
                                    width="100%" 
                                    height="100%" 
                                    autoPlay 
                                    muted 
                                    loop 
                                    playsInline
                                    poster={item.thum}
                                    src={item.video}
                                    >
                                    소개 영상입니다.
                                    </HLSVideo>
                                </div>}
                                <div className="title_box">
                                    <p>{lang === 0 ? item.title.ko : item.title.en}</p>
                                    <span style={{ whiteSpace: 'pre-line' }}>
                                    {lang === 0 ? item.description.ko : item.description.en}
                                    </span>
                                </div>
                                </>
                            )}
                            </div>
                        );
                        })}
                    </div>
                </div>

                <div className="page_start_banner">
                    <div className="content">
                        <p className="title">
                            {lang === 0 ? 
                                <>
                                    미래의 작업 방법을 경험해보세요!
                                </>
                                :
                                <>
                                    Experience the Future of Workflow!
                                </>
                            }
                        </p>

                        <div className="btn_box">
                            <button
                                type="button"
                                className={`start ${lang === 1 ? 'eng' : ''}`}
                                style={{width: 220,}}
                                onClick={() => {
                                    navigate(routes.Price);
                                }}
                            >
                                {lang === 0 ? '무료로 써보기' : 'Try for Free'}
                            </button>
                            <button
                                type="button"
                                className={`inquiry ${lang === 1 ? 'eng' : ''}`}
                                style={{width: 220,}}
                                onClick={() => {
                                    navigate(routes.Inquiry);
                                }}
                            >
                                {lang === 0 ? '문의하기' : 'Contact Us'}
                            </button>
                        </div>
                    </div>
                </div>
                
            </div> {/* 메인 div */}

            <ToastContainer
                position="bottom-center"
                transition={Slide}
                limit={1}
                closeButton={false}
                autoClose={1000}
                style={{ width: isBrowser ? 400 : '100%', marginBottom: isBrowser ? 60 : 70 }}
                hideProgressBar
            />
        </>
    );
}
